import { render } from "./IconLamp.vue?vue&type=template&id=36e6718a"
import script from "./IconLamp.vue?vue&type=script&lang=js"
export * from "./IconLamp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__